export const config = {
	apiKey: "AIzaSyDf21aNNnzcuDJqxjDiKEnHI5wk0vxvTRw",
	authDomain: "alsjkdfh.firebaseapp.com",
	projectId: "alsjkdfh",
	storageBucket: "alsjkdfh.firebasestorage.app",
	messagingSenderId: "664930921766",
	appId: "1:664930921766:web:d16000ffb0fe9f74f965e7",
	measurementId: "G-DDZ0RZYM1T",
};
